'use strict';

import * as validator from './clientSideValidation';
import {addEventListenerList} from '../helpers/utilities';

const
    validationRegEx = {
        phone: /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/,
        postalCode: {
            ch: {
                regex: /^[1-9]\d{3}$/,
                format: '1234'
            },
            de: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            at: {
                regex: /^[1-9]\d{3}$/,
                format: '1234'
            },
            cz: {
                regex: /(^\d{5}$)|(^(\d{3} \d{2})$)/,
                format: '123 45'
            },
            fr: {
                regex: /^(?:[0-8]\d|9[0-8])\d{3}$/,
                format: '12345'
            },
            mc: {
                regex: /^(?:[0-8]\d|9[0-8])\d{3}$/,
                format: '12345'
            },
            gb: {
                regex: /^([A-Z]{1,2}\d{1,2}[A-Z]?)( {0,1})(\d[A-Z]{2})$/,
                format: 'AA12 3BB'
            },
            jp: {
                regex: /^\d{3}-\d{4}$/,
                format: '123-4567'
            },
            in: {
                regex: /^[1-9]\d{5}$/,
                format: '123456'
            },
            it: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            gr: {
                regex: /^\d{3} \d{2}$/,
                format: '123 45'
            },
            tr: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            be: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            nl: {
                regex: /^\d{4} [A-Za-z]{2}$/,
                format: '1234 AB'
            },
            lu: {
                regex: /(^[A-Za-z]{1}[-]\d{4}$)|(^\d{4}$)/,
                format: 'A-1234 | 1234'
            },
            dk: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            se: {
                regex: /^\d{3} \d{2}$/,
                format: '123 45'
            },
            es: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            pt: {
                regex: /^\d{4}[-]\d{3}$/,
                format: '1234-123'
            },
            sg: {
                regex: /^[\d]{1,6}$/,
                format: '123456'
            },
            my: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            th: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            au: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            us: {
                regex: /^\d{5}(-\d{4})?$/,
                format: '12345'
            },
            ca: {
                regex: /^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]\d[A-Za-z] \d[A-Za-z]\d$/,
                format: 'A1A 1A1'
            },
            dz: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            ar: {
                regex: /^[a-zA-Z]?\d{4}$|^[a-zA-Z]{1}\d{4}[a-zA-Z]{3}$/,
                format: '12345 | A1234 | A1234ABC'
            },
            bm: {
                regex: /^[a-zA-Z]{2} \d{2}$/,
                format: 'AB 12'
            },
            br: {
                regex: /^\d{5}-\d{3}$/,
                format: '12345-678'
            },
            bn: {
                regex: /^[a-zA-Z]{2}\d{4}$/,
                format: 'AB1234'
            },
            cl: {
                regex: /^\d{7}$/,
                format: '1234567'
            },
            cn: {
                regex: /^\d{6}$/,
                format: '123456'
            },
            cr: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            hr: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            cy: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            ec: {
                regex: /^EC\d{6}$/,
                format: 'EC123456'
            },
            fi: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            gg: {
                regex: /^[\w\s-]{1,9}$/,
                format: 'A-Z 0-9'
            },
            hn: {
                regex: /^[a-zA-Z]{2}\d{4}$/,
                format: 'AB1234'
            },
            hu: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            is: {
                regex: /^\d{3}$/,
                format: '123'
            },
            id: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            ir: {
                regex: /^\d{10}$/,
                format: '1234567890'
            },
            il: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            je: {
                regex: /^[\w\s-]{1,9}$/,
                format: 'A-Z 0-9'
            },
            kz: {
                regex: /^\d{6}$/,
                format: '123456'
            },
            kp: {
                regex: /^[\w\s-]{1,7}$/,
                format: 'A-Z 0-9'
            },
            kr: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            kw: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            lb: {
                regex: /^\d{4}( \d{4})?$/,
                format: '1234'
            },
            ls: {
                regex: /^\d{3}$/,
                format: '123'
            },
            li: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            mt: {
                regex: /^[a-zA-Z]{3} \d{4}$/,
                format: 'ABC 1234'
            },
            mu: {
                regex: /^\d{3}[a-zA-Z]{2}\d{3}$/,
                format: '123AB456'
            },
            mx: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            np: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            nz: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            ni: {
                regex: /^\d{3}-\d{3}-\d$/,
                format: '123-456-7'
            },
            no: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            ps: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            pa: {
                regex: /^0\d{3}(-\d{5})?$/,
                format: '0123'
            },
            ph: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            pl: {
                regex: /^\d{2}-\d{3}$/,
                format: '12-345'
            },
            ro: {
                regex: /^\d{6}$/,
                format: '123456'
            },
            ru: {
                regex: /^\d{6}$/,
                format: '123456'
            },
            sa: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            sk: {
                regex: /^\d{3} \d{2}$/,
                format: '123 45'
            },
            si: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            so: {
                regex: /^[a-zA-Z]{2} \d{5}$/,
                format: 'AB 12345'
            },
            za: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            tw: {
                regex: /^\d{3}(\d{2}|\d{3})?$/,
                format: '1234'
            },
            tn: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            ua: {
                regex: /^\d{5}$/,
                format: '12345'
            },
            ve: {
                regex: /^\d{4}$/,
                format: '1234'
            },
            vn: {
                regex: /^\d{6}$/,
                format: '123456'
            },
            default: {
                regex: /^[\w\s-]*$/,
                format: 'A-Z 0-9'
            }
        },
        taxCode: {
            it: {
                regex: /^([A-Z]{3})([A-Z]{3})([0-9]{2})([A-Z]{1})([0-9]{2})([A-Z]{1})([0-9]{3})([A-Z]{1})$/
            },
            default: {
                regex: /^([A-Z]{3})([A-Z]{3})([0-9]{2})([A-Z]{1})([0-9]{2})([A-Z]{1})([0-9]{3})([A-Z]{1})$/
            }
        }
    },
    parser = new DOMParser();

validator.setupFormList();

function _getPostalCodeStructure(postalField) {
    let validationContext = postalField.attributes['data-validation-context'] && postalField.attributes['data-validation-context'].value || null,
        countrySelector = validationContext ? '#' + validationContext + 'Country' : '[name*="_countryCode"]',
        choosedCountry = postalField.form.querySelector(countrySelector),
        selectedCountryID = choosedCountry && choosedCountry.value ? choosedCountry.value : window.SFRA.Constants.LOCALE_COUNTRY;

    return validationRegEx.postalCode[selectedCountryID.toLowerCase()] || validationRegEx.postalCode.default;
}

function _getTaxCodeStructure(field) {
    let selectedCountry = field.form.querySelector('[name*="_countryCode"]'),
        selectedCountryID = selectedCountry && selectedCountry.value ? selectedCountry.value : window.SFRA.Constants.LOCALE_COUNTRY;

    return validationRegEx.taxCode[selectedCountryID.toLowerCase()] || validationRegEx.taxCode.default;
}

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 */
function validatePhone(value) {
    return !value || validationRegEx.phone.test(value.trim());
}

function validateSuppliedPhone(value) {
    var regSupPhone = new RegExp(window.SFRA.SitePreferences.suppliedPhoneNumberRegExp);
    return !value || regSupPhone.test(value.trim());
}

function validateIntlPhone(value, field) {
    if (!window.intlTelInputGlobals) {
        return validatePhone(value);
    }

    let intlInstance = window.intlTelInputGlobals.getInstance(field);

    return !value || intlInstance.isValidNumber();
}

/**
 * Use the postalCode regex table to verify a provided code against it.
 * If no country matches, then use the default regex.
 */
function postalCodeValidation(postalValue, postalField) {
    let postalStructure = _getPostalCodeStructure(postalField),
        isValid = true;

    if (postalStructure) {
        isValid = postalStructure.regex.test(postalValue.trim());
    }

    return !postalValue || isValid;
}

/**
 * Use the postalCode regex table to verify a provided code against it.
 * If no country matches, then use the default regex.
 */
function taxCodeValidation(taxValue, taxField) {
    let taxStructure = _getTaxCodeStructure(taxField),
        isValid = true;

    if (taxStructure) {
        isValid = taxStructure.regex.test(taxValue.trim());
    }

    return !taxValue || isValid;
}

/**
 * Returns true only if the value is a digit
 */
function validateNumeric(value) {
    return /^(\d+)$/.test(value.trim());
}

/**
 * Returns true only if the value lenght is 8 digit
 */
function validateCaseId(value) {
    let valid = true;
    if (value.length < 8) {
        return !valid;
    }

    return valid;
}

/**
 * Validates latin characters, non-control characters, and Arabic alphabet characters.
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
function validateArabicAndLatin(value) {
    var $currentSiteId = $('.current-site-id').data('current-site-id'),
        $isGiftCardMessage = $('.personalisation__card-textarea').data('line-item-component'),
        whiteSpaceStrip = value.replace(/\s/g, ''),
        koreanAndEnglishPatternMatch = new RegExp('[\u3131-\uD79DA-Za-z0-9\u0021-\u0040]', 'g'),
        noKoreanNoEnglishPatternMatch = new RegExp('[^\u3131-\uD79DA-Za-z0-9\u0021-\u0040]', 'g'),
        acceptableText = koreanAndEnglishPatternMatch.test(whiteSpaceStrip) && !noKoreanNoEnglishPatternMatch.test(whiteSpaceStrip);
    if ($currentSiteId !== 'undefined' && $currentSiteId === 'CartierKR' && $isGiftCardMessage === 'gift-msg-textarea') {
        return acceptableText === false ? false : true;
    } else {
        return !value || /^[\u0020-\u007E\u00A0\u00A7\u00AD\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(value.trim());
    }
}

/**
 * Validate Arabic characters only + spaces.
 */
function validateArabic(value) {
    return !value || /^[\u0020\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(value.trim());
}

/**
 * Validate Arabic characters, numbers and punctuation, spaces.
 */
function validateArabicForUAEOrKSA(value) {
    return !value || /^[\u0600-\u06FF\d\s\-\_\.\,\;\:\!\؟\(\)\[\]\{\}\،\.\؛\:\(\)\?\!\"\'\`\/\\]+$/.test(value.trim());
}
/**
 * Validate A-Z characters, numbers, and punctuation only.
 */
function validateAlphanumeric(value) {
    return !value || /^[\u0020-\u007E\u00A0\u00A7\u00AD]+$/.test(value.trim());
}

/**
 * validate A-Z characters, numbers, punctuation, nextline
 */
function validateGiftmessage(value) {
    return !value || /^[\u0020-\u007E\u00A0\u00A7\u00AD\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\n]+$/.test(value.trim());
}

/**
 * Validate English characters and accent characters only + spaces, apostrophe and hyphen.
 */
function validateLatin(value) {
    return !value || /^[a-zA-Z\u0020\u0027\u002D\u00C0-\u00FF\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF]+$/.test(value.trim());
}

/**
 * Validate that address line is not a PO Box.
 */
function validateNonPoBox(value) {
    return !value || !/\bp\.? *o\.? *box\b/i.test(value.trim());
}

/**
 * Validate that state code is set when required for US or CA.
 */
function validateBillingStateCode(value) {
    let countrySelector = document.querySelector('[data-billing-address="country-code"]'),
        stateField = document.querySelector('[data-billing-address-state-code]'),
        localeCountry = stateField && stateField.attributes['data-billing-address-state-code'].value || 'US';

    if (localeCountry == 'CA' || localeCountry == 'US') {
        return !((countrySelector.value === 'US' || countrySelector.value === 'CA') && !value.trim());
    } else {
        return !(countrySelector.value === localeCountry && !value.trim());
    }
}

/**
 * Checks if two field values match.
 */
function validateMatch(value, field) {
    let matchingEl = field.form.querySelector(field.getAttribute('data-validate-match')),
        matchingElValue = matchingEl.value;

    return value.toLowerCase() === matchingElValue.toLowerCase();
}

function validateRequired(value) {
    return !!value.trim();
}

/**
 * Validates if all constraints available in the "data-validate-constraints" attribute pass their individual validations.
 */
function validateConstraints(value, field) {
    let validationRules = JSON.parse(field.getAttribute('data-validate-constraints')),
        isValid = true;

    for (let key in validationRules) {
        if (validationRules[key].value) {
            let currentRegex = new RegExp(`.*${validationRules[key].regex}.*`);

            if (!currentRegex.test(field.value)) {
                field.dataset.constraintKey = key;
                field.dataset.constraintValue = validationRules[key].value;

                isValid = false;
            }
        }
    }

    return isValid;
}

/**
 * Toggles the necessary states for each field within `dependentEls`.
 * The `setRequired` flag is used to determine wether or not the field should be required.
 */
function _toggleDependentRequired(dependentEls, setRequired) {
    [].forEach.call(dependentEls, function(currentInput) {
        currentInput.required = setRequired;

        //If nothing is required, clear all validity.
        if (!setRequired) {
            validator.clearValidity(currentInput);
        }

        //If an error is currently visible, ensure that field gets re-validated after a sibling is changed.
        if (currentInput.classList.contains(validator.FIELD_INVALID_CLASS)) {
            validator.validateField(currentInput);
        }
    });
}

/**
 * Checks wether or not any field has a value, and returns TRUE if so.
 */
function _hasDependentValue(dependentEls) {
    for (let dependentEl of dependentEls) {
        if (dependentEl.value || dependentEl.checked) {
            return true;
        }
    }

    return false;
}

/**
 * Sets up two or more fields that are dependent on each other.
 * That is, if one field has a value, the other(s) are automatically set as required.
 * If no fields have values, then non are required.
 */
function setupRequiredDependency(formEl) {
    let dependencyGroupEls = (formEl || document).querySelectorAll('[data-dependency-group]');

    [].forEach.call(dependencyGroupEls, function(currentGroup) {
        let dependentEls = currentGroup.querySelectorAll('[data-validate-required-dependency]');

        addEventListenerList(dependentEls, 'change blur', function() {
            _toggleDependentRequired(dependentEls, _hasDependentValue(dependentEls));
        });
    });
}

/**
 * Removes any unwanted HTML tags from input elements, preventing hypothetical attacks.
 * @param  {NodeElement} el [description]
 */
function cleanInputScripts(value, field) {
    if (value && (field.nodeName === 'TEXTAREA' || (field.type && field.type !== 'file'))) {
        let parsedHTML = parser.parseFromString(value, 'text/html');

        field.value = parsedHTML.body.textContent;
    }

    return true;
}

function validateMaxLength(value, field) {
    let maxLength = field.getAttribute('data-validate-max') || 49;

    return value.trim().length <= maxLength;
}

/**
 * Validates that required consent is accepted.
 * @param value - Field Value.
 * @param field - Consent input field.
 * @returns {boolean} Consent validity.
 */
function validateRequiredConsent(value, field) {
    const yesField = _getConsentYesField(field);
    return yesField.checked;
}

/**
 * @function
 * @description Retrieves the yes input field by given consent field.
 * @param {HTMLInputElement} field - Yes/No input field.
 * @returns {HTMLInputElement} Yes input field.
 */
function _getConsentYesField(field) {
    return document.querySelector(`#${field.id.replace(/-(yes|no)$/i, '-yes')}`);
}

function validateTextareaWithPattern(value, field) {
    var regex = new RegExp(field.attributes.pattern.value, 'g');
    return regex.test(value);
}

function usePattenMessage(value, field) {
    return field.getAttribute('data-pattern-mismatch') || window.SFRA.Resources.patternMismatch;
}

function validateSpecialCharsAddress(value) {
    var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return !value || !(format.test(value.trim()));
}
validator.addValidation('textarea[pattern]', validateTextareaWithPattern, usePattenMessage);

validator.addValidation('data-validate-match', validateMatch, window.SFRA.Resources.matchingFormat);

validator.addValidation('data-validate-phone', validatePhone, window.SFRA.Resources.phoneFormat);

validator.addValidation('data-validate-intl-phone', validateIntlPhone, window.SFRA.Resources.phoneFormat);

validator.addValidation('data-validate-numeric', validateNumeric, window.SFRA.Resources.numericFormat);

validator.addValidation('data-validate-latin-arabic', validateArabicAndLatin, window.SFRA.Resources.alphabetFormat);

validator.addValidation('data-validate-arabic', validateArabic, window.SFRA.Resources.arabicFormat);

validator.addValidation('data-validate-arabic-characters', validateArabicForUAEOrKSA, window.SFRA.Resources.arabicFormat);

validator.addValidation('data-validate-taxCode', taxCodeValidation, window.SFRA.Resources.taxCodeFormat);

validator.addValidation('data-validate-alphanumeric', validateAlphanumeric, window.SFRA.Resources.alphanumericFormat);

validator.addValidation('data-validate-giftmessage', validateGiftmessage, window.SFRA.Resources.giftmessageFormat);

validator.addValidation('data-validate-latin', validateLatin, window.SFRA.Resources.latinFormat);

validator.addValidation('data-validate-area', validateAreaInput, window.SFRA.Resources.areaFormat);

validator.addValidation('data-validate-non-pobox', validateNonPoBox, window.SFRA.Resources.nonPoBoxFormat);

validator.addValidation('data-validate-case-id', validateCaseId, window.SFRA.Resources.caseIdLength);

validator.addValidation('data-birth-day-validate', validator.validateBirthDayDate, window.SFRA.Resources.invalidBirthDate);

validator.addValidation('data-birth-year-validate', validator.validateBirthDayDate, window.SFRA.Resources.invalidBirthDate);

validator.addValidation('data-birth-month-validate', validator.validateBirthDayDate, window.SFRA.Resources.invalidBirthDate);

validator.addValidation('data-validate-address-specialchars', validateSpecialCharsAddress, window.SFRA.Resources.invalidSpecialCharsInAddress);

if (window.SFRA.SitePreferences.enableContactUsEmailPhoneNumber) {
    validator.addValidation('data-validate-supplied-phone', validateSuppliedPhone, window.SFRA.Resources.phoneFormat);
}
validator.addValidation('data-validate-billing-state-code', validateBillingStateCode, function(value, field) {
    return field.getAttribute('data-missing-error') || window.SFRA.Resources.requiredField.format(field.labels && field.labels[0] ? field.labels[0].textContent.trim() : '');
});

validator.addValidation('data-validate-max', validateMaxLength, function(value, field) {
    let dataValidateMax = field.getAttribute('data-validate-max') || 49;
    return window.SFRA.Resources.maxLength.format(dataValidateMax);
});

validator.addValidation('data-validate-constraints', validateConstraints, function(value, field) {
    return window.SFRA.Resources.constraints[field.dataset.constraintKey].format(field.dataset.constraintValue);
});

validator.addValidation('data-validate-postal-code', postalCodeValidation, function(value, field) {
    let postalStructure = _getPostalCodeStructure(field);

    return postalStructure ? window.SFRA.Resources.postalFormatX.format(postalStructure.format) : window.SFRA.Resources.postalFormat;
});

validator.addValidation('required', validateRequired, function(value, field) {
    return field.getAttribute('data-missing-error') || window.SFRA.Resources.requiredField.format(field.labels && field.labels[0] ? field.labels[0].textContent.trim() : '');
});

validator.addValidation('*', cleanInputScripts, '');

validator.setDefaultMessages({
    'emptyRadio': window.SFRA.Resources.emptyRadio,
    'invalidEmail': window.SFRA.Resources.invalidEmail,
    'patternMismatch': window.SFRA.Resources.patternMismatch
});

validator.addValidation('data-validate-required-consent', validateRequiredConsent, function(value, field) {
    const yesField = _getConsentYesField(field);
    const label = yesField.labels && yesField.labels[0];
    return yesField.getAttribute('data-missing-error') || window.SFRA.Resources.requiredField.format(label ? label.textContent.trim() : '');
});

setupRequiredDependency();

/**
 * Setup validation listeners.
 * Useful to re-initialize validation after a dynamic component loads, i.e. a modal.
 * @param  {[type]} targetForm [description]
 * @return {[type]}            [description]
 */
export function init(targetForm) {
    let matchingForms = targetForm ? targetForm.querySelectorAll(validator.FORM_SELECTOR) : validator.FORM_SELECTOR;

    setupRequiredDependency(targetForm);

    validator.setupFormList(matchingForms);
}

function validateAreaInput(value) {
    var regex = /^[a-zA-Z, -]*$/;
    if (!regex.test(value)) {
        return false;
    }
    return true;
}
